import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private _isStorageActive = new BehaviorSubject(true);

  getStorageActiveObservable(): Observable<boolean> {
    return this._isStorageActive.asObservable();
  }

  setStorageActive(isStorageActive: boolean): void {
    this._isStorageActive.next(isStorageActive);
  }

  async setItem(key: string, value: string, isLocal = false): Promise<void> {
    try {
      const storage = isLocal ? localStorage : sessionStorage;
      storage.setItem(key, value);
    } catch (e) {
      this.onStorageError();
    }
  }

  getItem(key: string, isLocal = false): string | undefined {
    try {
      const storage = isLocal ? localStorage : sessionStorage;
      return storage.getItem(key);
    } catch (e) {
      this.onStorageError();
    }
  }

  async removeItem(key: string, isLocal = false): Promise<void> {
    try {
      const storage = isLocal ? localStorage : sessionStorage;
      return storage.removeItem(key);
    } catch (e) {
      this.onStorageError();
    }
  }

  clearStorage(isLocal = false): void {
    try {
      const storage = isLocal ? localStorage : sessionStorage;
      storage.clear();
    } catch (e) {
      this.onStorageError();
    }
  }

  onStorageError(): void {
    this.setStorageActive(false);
  }
}
